import { render, staticRenderFns } from "./CardContadores.vue?vue&type=template&id=5e53ba19&scoped=true&"
import script from "./CardContadores.vue?vue&type=script&lang=js&"
export * from "./CardContadores.vue?vue&type=script&lang=js&"
import style0 from "./CardContadores.vue?vue&type=style&index=0&id=5e53ba19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e53ba19",
  null
  
)

export default component.exports